import { useEffect, useRef } from "react";
import { useFloatingBubbles } from "../../../context/floating-bubbles/FloatingBubblesContext";
import { useInternalTwilioCall } from "../context/InternalTwilioCallContext";

/**
 * Opens the Contact Center bubble whenever a Twilio internal call is active,
 * matching InternalWebRTCCallSideEffects so both modes share the same shell UI.
 */
export const InternalTwilioCallSideEffects = () => {
  const { internalCallView, remoteIdentity } = useInternalTwilioCall();
  const { openCalls } = useFloatingBubbles();
  const openedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!internalCallView) {
      openedKeyRef.current = null;
      return;
    }

    const openKey = `${internalCallView}:${remoteIdentity ?? "unknown"}`;
    if (openedKeyRef.current === openKey) return;

    openedKeyRef.current = openKey;
    openCalls();
  }, [internalCallView, remoteIdentity, openCalls]);

  return null;
};
